import { render, staticRenderFns } from "./CustomSearchField.vue?vue&type=template&id=6165a844"
import script from "./CustomSearchField.vue?vue&type=script&lang=js"
export * from "./CustomSearchField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports